import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $(this.element).on("change", () => {
      const url = $(this.element).val()
      if (url && url.trim() !== "") {
        if (this.element.getAttribute("data-turbo") == "true") {
          fetch(url, {
            headers: {
              Accept: "text/vnd.turbo-stream.html"
            }
          })
          .then(r => r.text())
          .then(html => window.Turbo.renderStreamMessage(html))
        } else {
          window.location = url
        }
      }
    })
  }
}
